// export function formatRupiah(value) {
//   if (value === undefined || value === null) return ""; // handle null/undefined

//   let strValue = value.toString(); // konversi dulu ke string

//   // hapus semua karakter selain digit
//   let numberString = strValue.replace(/[^,\d]/g, "").toString();

//   // pisahkan desimal dan ribuan
//   let split = numberString.split(",");
//   let sisa = split[0].length % 3;
//   let rupiah = split[0].substr(0, sisa);
//   let ribuan = split[0].substr(sisa).match(/\d{3}/gi);

//   if (ribuan) {
//     let separator = sisa ? "." : "";
//     rupiah += separator + ribuan.join(".");
//   }

//   rupiah = split[1] !== undefined ? rupiah + "," + split[1] : rupiah;

//   return "Rp " + rupiah;
// }

export function formatRupiah(value) {
  if (value === undefined || value === null) return ""; // handle null/undefined

  // Cek apakah negatif
  let isNegative = Number(value) < 0;

  // konversi ke string dan hapus tanda minus jika ada
  let strValue = Math.abs(Number(value)).toString();

  // hapus semua karakter selain digit dan koma
  let numberString = strValue.replace(/[^,\d]/g, "");

  // pisahkan desimal dan ribuan
  let split = numberString.split(",");
  let sisa = split[0].length % 3;
  let rupiah = split[0].substr(0, sisa);
  let ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  if (ribuan) {
    let separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  rupiah = split[1] !== undefined ? rupiah + "," + split[1] : rupiah;

  // Jika negatif, bungkus dalam tanda kurung
  if (isNegative) {
    return "(Rp " + rupiah + ")";
  }

  return "Rp " + rupiah;
}
